import { useRoutes, Navigate } from 'react-router-dom'
import { useUser } from '../context/CurrentUserContext'
import layoutRegistry from '../layouts/layoutRegistry'
import NoAuthRoutes from './NoAuthRoutes'
import MainRoutes from './MainRoutes'
import ErrorPage from '../components/ErrorPage'

// Wrap each route's element with layout and layoutProps
const wrapRoutesWithLayouts = (route) => {
  const processedRoute = { ...route }

  if (processedRoute.layoutType && layoutRegistry[processedRoute.layoutType]) {
    const Layout = layoutRegistry[processedRoute.layoutType]

    processedRoute.element = (
      <Layout layoutProps={processedRoute?.layoutProps}>
        {processedRoute.element}
      </Layout>
    )
  }

  if (processedRoute.children) {
    processedRoute.children = processedRoute.children.map(wrapRoutesWithLayouts)
  }

  return processedRoute
}

const AppRoutes = () => {
  const { user } = useUser()

  const processedRoutes = [
    wrapRoutesWithLayouts(MainRoutes),
    wrapRoutesWithLayouts(NoAuthRoutes),
  ]

  const routes = [
    ...processedRoutes,
    {
      path: '*',
      element: user ? <ErrorPage /> : <Navigate to="/login" replace />,
    },
  ]

  return useRoutes(routes)
}

export default AppRoutes
